export default "__VITE_ASSET__DpfXG7mA__"